import { connect } from 'react-redux'

import { blockWelcomeModal } from 'MarketPlace/shared/actions'
import Smartphones from 'MarketPlace/Advertising/views/AdvertisingFrameView/containers/Smartphones'
import Tablets from 'MarketPlace/Advertising/views/AdvertisingFrameView/containers/Tablets'

import { getCurrentDeviceView } from 'shared/helpers/utils'

const AdvertisingFrameView = getCurrentDeviceView(Smartphones, Tablets)

const mapStateToProps = (state) => ({
  t: state.i18n.get('app', 'views', 'MarketPlace'),
  selectedCategory: state.marketplace.index.category
})
const mapDispatchToProps = dispatch => ({
  blockWelcomeModal: (...args) => dispatch(blockWelcomeModal(...args))
})

export default connect(mapStateToProps, mapDispatchToProps)(AdvertisingFrameView)
